import { SAMPLE_AGS_DEMOS } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/dataLayersTool.helpers';
import type { AppState } from '~/store/app.store';

export const mapSettingsDataLayersPrimaryBoundaryGroupIdSelector = (_state: AppState) =>
  SAMPLE_AGS_DEMOS[0].boundaryGroupId;
